import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed w-full z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center">
            <span className="font-bold text-2xl text-ribyte-900">Ribyte</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 items-center">
            <a href="#solutions" className="text-gray-600 hover:text-ribyte-600 font-medium transition-colors">Soluciones</a>
            <a href="#ryo" className="text-gray-600 hover:text-ribyte-600 font-medium transition-colors">Producto RYO</a>
            <a href="#about" className="text-gray-600 hover:text-ribyte-600 font-medium transition-colors">Nosotros</a>
            <button className="bg-ribyte-600 text-white px-5 py-2.5 rounded-lg font-medium hover:bg-ribyte-700 transition-colors shadow-sm">
              Contactar
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-600 hover:text-ribyte-600 focus:outline-none"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg">
          <div className="px-4 pt-2 pb-6 space-y-2">
            <a href="#solutions" className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-ribyte-600 hover:bg-ribyte-50 rounded-md">Soluciones</a>
            <a href="#ryo" className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-ribyte-600 hover:bg-ribyte-50 rounded-md">Producto RYO</a>
            <a href="#about" className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-ribyte-600 hover:bg-ribyte-50 rounded-md">Nosotros</a>
            <div className="pt-4">
              <button className="w-full bg-ribyte-600 text-white px-5 py-3 rounded-lg font-medium hover:bg-ribyte-700 transition-colors">
                Contactar
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
